module.exports = __webpack_public_path__ + "static/media/checkmark.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/checkmark.svg
// module id = 511
// module chunks = 0